let currentTooltipId: string | null = null;
const listeners = new Set<() => void>();

export const generateTooltipId = (): string =>
  `tooltip-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;

export const openTooltip = (id: string): void => {
  currentTooltipId = id;
  listeners.forEach((listener) => listener());
};

export const onTooltipOpen = (id: string, onClose: () => void): (() => void) => {
  const handler = (): void => {
    if (currentTooltipId !== id) {
      onClose();
    }
  };

  listeners.add(handler);

  return (): void => {
    listeners.delete(handler);
  };
};
